import { FontEntry } from '../../types/font'

export const roboto: FontEntry = {
  displayName: 'Roboto',
  weights: {
    300: {
      normal: { file: 'Roboto-Light', extension: 'ttf', format: 'truetype' },
      italic: { file: 'Roboto-LightItalic', extension: 'ttf', format: 'truetype' }
    },
    400: {
      normal: { file: 'Roboto-Regular', extension: 'ttf', format: 'truetype' },
      italic: { file: 'Roboto-Italic', extension: 'ttf', format: 'truetype' }
    },
    700: {
      normal: { file: 'Roboto-Bold', extension: 'ttf', format: 'truetype' },
      italic: { file: 'Roboto-BoldItalic', extension: 'ttf', format: 'truetype' }
    }
  },
  fallbackMetrics: {
    arial: {
      regular: {
        sizeAdjust: 98.56,
        ascentOverride: 94.13,
        descentOverride: 24.77,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 94.39,
        ascentOverride: 98.29,
        descentOverride: 25.86,
        lineGapOverride: 0
      }
    },
    roboto: {
      regular: {
        sizeAdjust: 100,
        ascentOverride: 92.77,
        descentOverride: 24.41,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 100,
        ascentOverride: 92.77,
        descentOverride: 24.41,
        lineGapOverride: 0
      }
    }
  }
}
